export {
  ensureSymbolIndexFileImpl as ensureSymbolIndexFileInWorkerHost,
  indexOneSymbolFileForBuild,
} from './ensure-symbol-index-file-impl.js';
